export default function TdsToggle({ label, description, checked, onChange, disabled }) {
  return (
    <div className="tds-toggle-row">
      <div className="tds-toggle-info">
        <div className="tds-toggle-label">{label}</div>
        {description ? <div className="tds-toggle-desc">{description}</div> : null}
      </div>
      <label className="tds-switch">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange?.(e.target.checked)}
          disabled={disabled}
        />
        <span className="tds-switch-slider" />
      </label>
    </div>
  );
}
